import theme from '../../theme';

export const TreeItemSx = {
  color: theme.palette.customColors.gray[950],
};
